export { default } from './author-with-post-details';
